import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PauseSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PauseSVG;
